import React from 'react';
import { ContactSection } from '../components/sections/ContactSection';

const ContactPage = () => {
  return (
    <div className="pt-32 sm:pt-40" data-testid="contact-page">
      <ContactSection />
    </div>
  );
};

export default ContactPage;
